import withComponentName from '../../../../decorators/withComponentName';

import './styles.css';
import AmazonEchoIMG from '../../../../../../assets/images/corporate/amazon-echo.png';
import GoogleHomeIMG from '../../../../../../assets/images/corporate/google-home.png';
import AppIMG from '../../../../../../assets/images/corporate/app.png';

const CorporateClientCloud = () => (
  <div className="CCSection">
    <h1 className="CCSection__head">
      clients could access content
      at the command of their voice
    </h1>

    <div className="CCSection__devices">
      <div className="CCSection__devices--item">
        <div className="item__img">
          <img src={AppIMG} />
        </div>
        <p className="item__title">Your App</p>
      </div>
      <div className="CCSection__devices--item">
        <div className="item__img">
          <img src={GoogleHomeIMG} />
        </div>
        <p className="item__title">Google Home</p>
      </div>
      <div className="CCSection__devices--item">
        <div className="item__img">
          <img src={AmazonEchoIMG} />
        </div>
        <p className="item__title">Amazon Echo</p>
      </div>
    </div>
  </div>
);

export default withComponentName(CorporateClientCloud);
